import React from "react";
import Eyebrow from "./Eyebrow";

const FinalCtaSection = () => {
  return (
    <section className="flex flex-col lg:flex-row lg:justify-between items-start lg:items-center gap-[30px] lg:gap-[70px] text-white bg-primary py-[68px] lg:py-20 px-[18px] sm:px-[max(26px,50vw-640px)]">
      <div>
        <Eyebrow light>YOUR NEXT STEP</Eyebrow>
        <h2 className="tracking-[-0.045em] max-w-[900px] font-bold mb-[14px] text-corp-cta-h2 leading-[1.14]">
          Your workforce strategy deserves more than a content library.
        </h2>
        <p className="text-[#d7dfff] max-w-[760px] m-0 text-[17px] leading-[1.72]">
          Tell us what your people need to be able to do and we&rsquo;ll help
          design the pathway.
        </p>
      </div>
      <a
        href="mailto:info@utiva.io?subject=Corporate%20Training%20Enquiry"
        className="w-full lg:w-auto inline-flex items-center justify-center gap-[11px] min-h-[54px] px-[22px] py-[14px] rounded-xl border border-secondary bg-secondary text-primary text-[15px] font-750 flex-none transition-all duration-[180ms] hover:bg-[#ffc342] hover:-translate-y-0.5"
      >
        Start the conversation <span aria-hidden="true">↗</span>
      </a>
    </section>
  );
};

export default FinalCtaSection;
